import { createApi } from '@reduxjs/toolkit/query/react';
import { apiBaseQuery, post } from '../helpers';

const workflowApi = createApi({
  reducerPath: 'workflow',
  tagTypes: [],
  baseQuery: apiBaseQuery('/workflow'),
  endpoints: (builder) => ({
    swapConversationCustomer: builder.mutation<void, { conversationId: string; customerId: string }>({
      query: ({ conversationId, customerId }) => post(`/api/conversation/${conversationId}/setData`, [{ Key: 'CustomerId', Value: customerId }]),
    }),
  }),
});

export const {
  useSwapConversationCustomerMutation,
} = workflowApi;

export default workflowApi;